import React from 'react';
// importante: atualizar os pacotes aí
import { Infos, Especialidades, Footer, Header, Sobre, Contato } from './containers';
import { NavBar, InfoAdicional, FloatingWhats } from './components';
import './App.css';

const App = () => {
  return (
    <div>
      <div className="header__bg">
        <NavBar />
        <Header />
        <FloatingWhats />
      </div>
      <div className="body__bg">
        <Sobre />
        <Especialidades />
        <InfoAdicional />
        <Infos />
        {/* novo componente do instragram: adicionar um efeito de passar o mouse e meio que "girar" a foto, expandir, deixar um sombreado embaixo e tal */}
        {/* o de depoimento não é pra ser muito difícil pelo visto, basicamente cria um componente menor pra cada depoimento, talvez um efeito de expandir cada um, dar um zoom, algo assim, e um container com o estilo deles espalhados e tal */}
        <Contato />
        <Footer />
      </div>
    </div>
  );
}

export default App;
